// Modules
import { ConfirmModalModule } from 'NewAngular/features/components/modals/confirm-modal/confirm-modal.module';
import { CommonModule } from '@angular/common';
import { DisabledModule } from 'NewAngular/features/directives/disabled/disabled.module';
import { FeatureNeededModule } from 'EntitlementsApp/ts/features/feature-needed/feature-needed.module';
import { IconModule } from 'NewAngular/features/directives/icon/icon.module';
import { LoadingSymbolModule } from 'NewAngular/features/components/loaders/loading-symbol/loading-symbol.module';
import { ModalBaseModule } from 'NewAngular/features/components/modals/modal-base/modal-base.module';
import { TooltipModule } from 'NewAngular/features/directives/popovers/tooltip/tooltip.module';
// Pipes
import { IsSharedWithOthersPipeModule } from 'SharingApp/ts/pipes/is-shared-with-others-pipe.module';
import * as i0 from "@angular/core";
export class OpenItemModalModule {
}
OpenItemModalModule.ɵfac = function OpenItemModalModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || OpenItemModalModule)(); };
OpenItemModalModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: OpenItemModalModule });
OpenItemModalModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [ConfirmModalModule,
        CommonModule,
        DisabledModule,
        FeatureNeededModule,
        IconModule,
        IsSharedWithOthersPipeModule,
        LoadingSymbolModule,
        ModalBaseModule,
        TooltipModule] });
